// Module
var code = `<div class='modal-window-content-block'></div>

<table>
    <thead>
    <tr>
        <th>Window Event</th>
        <th>Window Channel Action</th>
    </tr>
    </thead>
    <tbody>
        {{#content}}
        <tr>
            <td>{{event}}</td>
            <td>{{action}}</td>
        </tr>
        {{/content}}
    </tbody>
</table>
`;
// Exports
module.exports = code;